import "./Rules.css";
const Rules = () => {
    return (
        <div className="RulesComponent">
            <div className="Rules">
                <h1 className="text primary">قوانین سایت</h1>
                <h2 className="text secondary">
                    باتشکر از همراهان و مشتریان خرازی اینترنتی نیکا قبل از ثبت
                    سفارش در سایت فیلم آموزشی نحوه ثبت نام و ثبت سفارش که در
                    صفحه اول سایت قرار دارد را تماشا کنید و موارد زیر را مطالعه
                    کنید.
                </h2>
                <p>
                    <i className="fa-solid fa-triangle-exclamation text info"></i>
                    با این که جهت رفاه حال مشتریان عزیز و
                    <div className="imp">سهولت در استفاده از سایت</div>
                    امکان
                    <div className="imp">ثبت سفارش بدون عضویت</div>
                    در سایت وجود دارد اما
                    <div className="imp">پیشنهاد میشود</div>
                    جهت استفاده از تمام امکانات سایت و پیگیری های آتی در سایت
                    <div className="imp">عضو شوید</div>.
                </p>
                <p>
                    <i className="fa-solid fa-triangle-exclamation  text danger"></i>
                    هنگام ثبت سفارش و انتخاب روش
                    <div className="imp">پرداخت آفلاین</div>
                    (روش های کارت به کارت / حساب به حساب / پایا) یک پیش فاکتور
                    برای شما به نمایش در می آید
                    <div className="imp">
                        حتما شماره پیش فاکتور را نزد خود نگه دارید
                    </div>
                    زیرا زمان ارسال مشخصات واریز وارد کردن این شماره پیش فاکتور
                    <div className="imp">الزامی</div>
                    است. فروشگاه
                    <div className="imp">
                        هیچ مسئولیتی در قبال عدم ذخیره شماره پیش فاکتور از سوی
                        شما ندارد
                    </div>
                    . فقط کاربرانی که
                    <div className="imp">عضو</div>
                    سایت باشند میتوانند به این شماره از طریق پنل کاربری خود و
                    بخش سفارشات دسترسی داشته باشند.
                </p>
                <p>
                    <i className="fa-solid fa-triangle-exclamation text warning"></i>
                    هنگام درج اطلاعات مانند ادرس و تلفن همراه دقت لازم را لحاظ
                    کنید تا
                    <div className="imp">اطلاعات درست و دقیق باشد </div>
                    همچنین شماره تلفنی که ثبت میکنید
                    <div className="imp">دردسترس باشد</div>
                    در غیر این صورت فروشگاه در مشکلات ارسال به دلبل اشتباه بودن
                    مشخصات تعهدی نخواهد داشت.
                </p>
                <p>
                    <i className="fa-solid fa-triangle-exclamation text warning"></i>
                    هنگام ثبت سفارش دقت کنید بعد از ثبت نهایی سفارش امکان حذف و
                    یا تغیر سفارش و نحوه {"ارسال "}
                    <div className="imp">{" وجود ندارد "}</div>.
                </p>
                <p>
                    <i className="fa-solid fa-triangle-exclamation text warning"></i>
                    سفارش شما
                    <div className="imp">حداقل ۷۲ {"ساعت "}</div>
                    {" پس"} از ثبت نهایی(به جز جمعه ها وایام تعطیل) تحویل پست یا
                    تیپاکس میشود و
                    <div className="imp">بین سه تا ده روز کاری</div>
                    زمان میبرد که از طریق پست به دست شما برسد و شما میتوانید با
                    کدرهگیری که ازسایت دریافت میکنید مرسوله خود را پیگیری
                    کنید(پیگیری مرسولات پستی برعهده گیرنده میباشد).
                </p>
                <p>
                    <i className="fa-solid fa-triangle-exclamation text warning"></i>
                    سفارشاتی که از {"طریق "}
                    <div className="imp">باربری</div>
                    ارسال میشوند فقط روز های
                    <div className="imp">دو شنبه یا سه شنبه</div>
                    به باربری تحویل داده میشوند.
                </p>
                <p>
                    <i className="fa-solid fa-triangle-exclamation text warning"></i>
                    درصورت مخدوش بودن یا باز بودن بسته از تحویل بسته از پستچی
                    خودداری کنید زیرا اکر خسارتی ازطرف پست به مرسوله شما وارد
                    شده باشد بعد از تحویل گرفتن نمیتوانیددرخواست خسارت کنید.
                </p>
                <p>
                    <i className="fa-solid fa-triangle-exclamation text danger"></i>
                    مرجوعی کالا تنها در صورتی امکان پذیر است که کالای شما در
                    <div className="imp">رنگ</div>
                    {" یا "}
                    <div className="imp">مدل</div>
                    {" یا "}
                    <div className="imp">جنس</div>و {" یا "}
                    <div className="imp">مقدار</div>
                    با سفارش شما مغایرت داشته باشد.
                </p>
                <p>
                    <i className="fa-solid fa-triangle-exclamation text warning"></i>
                    برای جلوگیری از هرزنویسه ها تنها کاربرانی {"که "}
                    <div className="imp">عضو سایت هستند</div>و آن کالا را
                    <div className="imp">خریداری کرده اند</div>
                    میتوانند در مورد آن کالا نظرات خود را بنویسند. نظرات پس از
                    <div className="imp">تایید مدیریت فروشگاه</div>
                    برای مشتریان به نمایش درخواهد آمد .
                </p>

                <p>
                    <i className="fa-solid fa-triangle-exclamation text warning"></i>
                    هنگام ثبت سفارش در دی تا اواخر بهمن و تیر،مرداد و شهریور ماه
                    که حجم سفارشات بالاهست
                    <div className="imp">
                        مدت زمان ارسال ممکن است از سه روز کاری بیشتر شود
                    </div>
                    .
                </p>

                <p>
                    <i className="fa-solid fa-triangle-exclamation text danger"></i>
                    <div className="imp">هرگونه کپی</div>
                    ازطرح های پارچه ها و پنل هایی که در مشخصات طرح اختصاصی ذکر
                    شده است
                    <div className="imp">پیگرد قانونی</div>
                    دارد.
                </p>
            </div>
        </div>
    );
};

export default Rules;
